module.exports = __webpack_public_path__ + "img/bottom.a7a5d00c.png";